/**
 * Régions et langues supportées
 * Couvre : Chine, Japon, Corée, Taïwan, Hong Kong, Thaïlande,
 *          Vietnam, Indonésie, Malaisie, Singapour, Philippines,
 *          Inde + toute l'Europe + US/CA + Moyen-Orient + Afrique
 */

export const REGIONS = {
  /* ── Chine & Grande Chine ─────────────────────── */
  CN: {
    code: 'CN', lang: 'zh-CN', name: '中国', nameEn: 'China',
    flag: '🇨🇳', currency: 'CNY', symbol: '¥',
    continent: 'asia',
    platforms: ['taobao', 'tmall', 'jd', 'pinduoduo', 'xiaohongshu'],
  },
  TW: {
    code: 'TW', lang: 'zh-TW', name: '台灣', nameEn: 'Taiwan',
    flag: '🇹🇼', currency: 'TWD', symbol: 'NT$',
    continent: 'asia',
    platforms: ['shopee_tw', 'momo', 'pchome', 'taobao'],
  },
  HK: {
    code: 'HK', lang: 'zh-HK', name: '香港', nameEn: 'Hong Kong',
    flag: '🇭🇰', currency: 'HKD', symbol: 'HK$',
    continent: 'asia',
    platforms: ['hktvmall', 'zalora_hk', 'asos', 'farfetch'],
  },
  /* ── Asie du Nord-Est ─────────────────────────── */
  JP: {
    code: 'JP', lang: 'ja', name: '日本', nameEn: 'Japan',
    flag: '🇯🇵', currency: 'JPY', symbol: '¥',
    continent: 'asia',
    platforms: ['rakuten', 'zozotown', 'amazon_jp', 'uniqlo'],
  },
  KR: {
    code: 'KR', lang: 'ko', name: '한국', nameEn: 'South Korea',
    flag: '🇰🇷', currency: 'KRW', symbol: '₩',
    continent: 'asia',
    platforms: ['coupang', 'musinsa', 'naver_shop', 'kakao_style'],
  },
  /* ── Asie du Sud-Est ──────────────────────────── */
  SG: {
    code: 'SG', lang: 'en', name: 'Singapore', nameEn: 'Singapore',
    flag: '🇸🇬', currency: 'SGD', symbol: 'S$',
    continent: 'asia',
    platforms: ['shopee_sg', 'zalora', 'lazada', 'asos'],
  },
  MY: {
    code: 'MY', lang: 'ms', name: 'Malaysia', nameEn: 'Malaysia',
    flag: '🇲🇾', currency: 'MYR', symbol: 'RM',
    continent: 'asia',
    platforms: ['shopee_my', 'lazada_my', 'zalora_my'],
  },
  TH: {
    code: 'TH', lang: 'th', name: 'ไทย', nameEn: 'Thailand',
    flag: '🇹🇭', currency: 'THB', symbol: '฿',
    continent: 'asia',
    platforms: ['shopee_th', 'lazada_th', 'central_online'],
  },
  ID: {
    code: 'ID', lang: 'id', name: 'Indonesia', nameEn: 'Indonesia',
    flag: '🇮🇩', currency: 'IDR', symbol: 'Rp',
    continent: 'asia',
    platforms: ['tokopedia', 'shopee_id', 'lazada_id', 'zalora_id'],
  },
  VN: {
    code: 'VN', lang: 'vi', name: 'Việt Nam', nameEn: 'Vietnam',
    flag: '🇻🇳', currency: 'VND', symbol: '₫',
    continent: 'asia',
    platforms: ['shopee_vn', 'lazada_vn', 'tiki'],
  },
  PH: {
    code: 'PH', lang: 'fil', name: 'Philippines', nameEn: 'Philippines',
    flag: '🇵🇭', currency: 'PHP', symbol: '₱',
    continent: 'asia',
    platforms: ['shopee_ph', 'lazada_ph', 'zalora_ph'],
  },
  /* ── Asie du Sud ──────────────────────────────── */
  IN: {
    code: 'IN', lang: 'hi', name: 'भारत', nameEn: 'India',
    flag: '🇮🇳', currency: 'INR', symbol: '₹',
    continent: 'asia',
    platforms: ['myntra', 'ajio', 'nykaa_fashion', 'flipkart'],
  },
  /* ── Europe ───────────────────────────────────── */
  FR: {
    code: 'FR', lang: 'fr', name: 'France', nameEn: 'France',
    flag: '🇫🇷', currency: 'EUR', symbol: '€',
    continent: 'europe',
    platforms: ['zalando', 'asos', 'net_a_porter', 'farfetch'],
  },
  DE: {
    code: 'DE', lang: 'de', name: 'Deutschland', nameEn: 'Germany',
    flag: '🇩🇪', currency: 'EUR', symbol: '€',
    continent: 'europe',
    platforms: ['zalando', 'about_you', 'asos', 'otto'],
  },
  /* ── US / Canada ──────────────────────────────── */
  US: {
    code: 'US', lang: 'en', name: 'United States', nameEn: 'United States',
    flag: '🇺🇸', currency: 'USD', symbol: '$',
    continent: 'americas',
    platforms: ['nordstrom', 'amazon', 'revolve', 'ssense'],
  },
  /* ── Moyen-Orient ─────────────────────────────── */
  AE: {
    code: 'AE', lang: 'ar', name: 'الإمارات', nameEn: 'UAE',
    flag: '🇦🇪', currency: 'AED', symbol: 'د.إ',
    continent: 'middle_east',
    platforms: ['namshi', 'ounass', 'sivvi', 'farfetch'],
  },
};

export const CONTINENTS = {
  asia:        { label: 'Asie',         icon: '🌏' },
  europe:      { label: 'Europe',       icon: '🌍' },
  americas:    { label: 'Amériques',    icon: '🌎' },
  middle_east: { label: 'Moyen-Orient', icon: '🌙' },
  africa:      { label: 'Afrique',      icon: '🌍' },
};

export const DEFAULT_REGION = 'FR';
